import React, { useEffect } from "react";

const NewsletterPrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-bold mb-4">E-Bülten Aydınlatma Metni</h1>
      <p className="mb-6">
        Aşağıda yer alan Kişisel Verilerin İşlenmesine İlişkin Aydınlatma
        Metni’ni okuyarak kişisel verilerinizi işleme amaçlarımızı ve bu
        kapsamda haklarınızı ayrıntılarıyla incelemenizi rica ediyoruz.
      </p>

      <h2 className="text-xl font-semibold mb-2">a) Veri Sorumlusu</h2>
      <p className="mb-4">
        6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca,
        kişisel verileriniz; veri sorumlusu olarak LENSA
        Sanayi ve Ticaret Anonim Şirketi (“Şirket”) tarafından aşağıda açıklanan
        kapsamda işlenmektedir.
      </p>

      <h2 className="text-xl font-semibold mb-2">
        b) Kişisel Verilerin İşlenme Amaçları, Toplama Yöntemleri ve Hukuki
        Sebepleri
      </h2>
      <table className="w-full table-auto border-collapse border border-gray-300 mb-6">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">
              İşlemeye Konu Kişisel Veri Kategorileri ve Tipleri
            </th>
            <th className="border border-gray-300 px-4 py-2">
              Kişisel Verilerinizin Hangi Amaçlarla İşleneceği
            </th>
            <th className="border border-gray-300 px-4 py-2">
              Kişisel Verilerinizin Hangi Yöntemle Toplandığı ve Hukuki Sebebi
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-300 px-4 py-2">
              İletişim: E-Posta Adresi
            </td>
            <td className="border border-gray-300 px-4 py-2">
              Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi, Ürün /
              Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi, İletişim
              Faaliyetlerinin Yürütülmesi
            </td>
            <td className="border border-gray-300 px-4 py-2">
              “İletişime Geçin” alanından otomatik yollarla toplanan kişisel
              verileriniz KVKK’nın 5. maddesinde belirtilen “İlgili kişinin
              temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri
              sorumlusu meşru menfaatleri için veri işlenmesinin zorunlu olması”
              ve “Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması
              kaydıyla, sözleşmenin taraflarına ait kişisel verilerin
              işlenmesinin gerekli olması” hukuki sebeplerine dayanılarak
              işlenmektedir.
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-xl font-semibold mb-2">
        c) İşlenen Kişisel Verilerinizin Kimlere ve Hangi Amaçlarla
        Aktarılabileceği
      </h2>
      <table className="w-full table-auto border-collapse border border-gray-300 mb-6">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">
              Yurt İçinde Yerleşik Üçüncü Taraf
            </th>
            <th className="border border-gray-300 px-4 py-2">
              Aktarıma Konu Olabilecek Kişisel Veri Kategorileri ve Tipleri
            </th>
            <th className="border border-gray-300 px-4 py-2">Aktarım Amacı</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-300 px-4 py-2">
              Yetkili kamu kurum ve kuruluşları
            </td>
            <td className="border border-gray-300 px-4 py-2">
              İletişim: E-Posta Adresi
            </td>
            <td className="border border-gray-300 px-4 py-2">
              Yetkili Kişi, Kurum ve Kuruluşlara Bilgi Verilmesi
            </td>
          </tr>
          <tr>
            <td className="border border-gray-300 px-4 py-2">Tedarikçiler</td>
            <td className="border border-gray-300 px-4 py-2">
              İletişim: E-Posta Adresi
            </td>
            <td className="border border-gray-300 px-4 py-2">
              Reklam / Kampanya / Promosyon Süreçlerinin Yürütülmesi, Ürün /
              Hizmetlerin Pazarlama Süreçlerinin Yürütülmesi, İletişim
              Faaliyetlerinin Yürütülmesi
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-xl font-semibold mb-2">
        d) İlgili Kişi Olarak KVKK Kapsamındaki Haklarınızla İlgili
        Bilgilendirme
      </h2>
      <p className="mb-6">
        İlgili Kişi olarak, KVKK’nın ilgili kişinin haklarını düzenleyen 11.
        maddesi kapsamındaki taleplerinizi Veri Sorumlusuna Başvuru Usul ve
        Esasları Hakkında Tebliğ’e göre Kaptanpaşa Mahallesi Halit Ziya Türkkan
        Sokak Famas Plaza C-Blok No:19/3 Şişli adresine yazılı olarak iletebilir
        veya{" "}
        <a href="mailto:kvkk@lensa.com.tr" className="text-blue-500">
          kvkk@lensa.com.tr
        </a>{" "}
        e-posta adresine e-posta yoluyla veya{" "}
        <a href="mailto:lensa.bilisim@hs01.kep.tr" className="text-blue-500">
          lensa.bilisim@hs01.kep.tr
        </a>{" "}
        kayıtlı elektronik posta (KEP) adresine iletebilirsiniz.
      </p>
      <p>
        Elektronik ticari ileti gönderimi kapsamında vermiş olduğunuz onayınızı
        …………… adresine e-posta göndererek, tarafınıza gönderilen e-postaların
        altında yer alan “ebülten üyeliğinizi sonlandırmak için buraya tıklayın”
        butonunu tıklayarak veya ………………….. iletişim numarasını arayarak her
        zaman geri alabilirsiniz.
      </p>
    </div>
  );
};

export default NewsletterPrivacyPolicy;
